/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Delete_Translation_Aria_LabelInputs */

const en_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this translation event`)
};

const fr_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cet evenement de traduction`)
};

const de_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Übersetzungsereignis löschen`)
};

const it_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina questo evento di traduzione`)
};

const ru_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить это событие перевода`)
};

const es_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar este evento de traducción`)
};

const zh_cn2_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除此翻译事件`)
};

const ja_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この翻訳イベントを削除する`)
};

const hi_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस अनुवाद इवेंट को हटाएँ`)
};

const pt_pt2_event_delete_translation_aria_label = /** @type {(inputs: Event_Delete_Translation_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir este evento de tradução`)
};

/**
* | output |
* | --- |
* | "Delete this translation event" |
*
* @param {Event_Delete_Translation_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_delete_translation_aria_label = /** @type {((inputs?: Event_Delete_Translation_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Delete_Translation_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_delete_translation_aria_label(inputs)
	if (locale === "de") return de_event_delete_translation_aria_label(inputs)
	if (locale === "it") return it_event_delete_translation_aria_label(inputs)
	if (locale === "ru") return ru_event_delete_translation_aria_label(inputs)
	if (locale === "es") return es_event_delete_translation_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_delete_translation_aria_label(inputs)
	if (locale === "ja") return ja_event_delete_translation_aria_label(inputs)
	if (locale === "hi") return hi_event_delete_translation_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_delete_translation_aria_label(inputs)
	return en_event_delete_translation_aria_label(inputs)
});